<template>
  <v-col col="12">
    <v-row
      ><v-col v-for="field in fields" :key="field.group" cols="12">
        <div class="flex flex-column">
          <h1 class="text-left mb-5">{{ field.group }}</h1>
          <v-row>
            <v-col
              v-for="(attrib, index) in field.attributes"
              :key="attrib.id"
              cols="12"
            >
              <div v-if="attrib.data_type === 'string'">
                <v-textarea
                  :label="attrib.label"
                  class="pt-0 mb-0"
                  outlined
                  :disabled="disabled"
                  v-if="
                    dynamicAttributes.find(
                      (dynamic) => dynamic.entity_attribute_id === attrib.id
                    ) !== undefined
                  "
                  :value="getValueField(attrib.id)"
                  @input="onDynamicField(index, attrib.id, $event)"
                ></v-textarea>

                <v-textarea
                  :label="attrib.label"
                  class="pt-0 mb-0"
                  outlined
                  :disabled="disabled"
                  v-else
                  @input="onDynamicField(index, attrib.id, $event)"
                ></v-textarea>
              </div>
              <div v-if="attrib.data_type === 'date'">
                <v-menu
                  ref="pickerEnd"
                  v-model="showDate"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      slot="activator"
                      class="pt-0 input-custom-56"
                      :label="attrib.label"
                      :value="getValueField(attrib.id)"
                      outlined
                      height="56"
                      :disabled="disabled"
                      append-icon="event"
                      readonly
                      @click:append="showDate = true"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    :value="getValueField(attrib.id)"
                    no-title
                    scrollable
                    reactive
                    :show-current="true"
                    locale="es"
                    :allowed-dates="allowedDates"
                    @input="
                      onDynamicField(index, attrib.id, $event, attrib.data_type)
                    "
                  ></v-date-picker>
                </v-menu>
              </div>
            </v-col>
          </v-row>
        </div> </v-col
    ></v-row>
  </v-col>
</template>

<script>
export default {
  name: "CustomFieldsAttributes",
  props: {
    extendedAttributes: { type: Array, default: () => [] },
    disabledOptions: { type: Boolean, default: false },
  },
  data: () => ({
    dynamicAttributes: [],
    fields: [],
    disabled: false,
    showDate: false,
  }),
  mounted() {
    this.fields = this.extendedAttributes;
    setTimeout(() => {
      this.dynamicAttributes = this.extendedAttributes
        .reduce((accumulator, group) => {
          return accumulator.concat(group.attributes);
        }, [])
        .map((attrib) => ({ value: "", entity_attribute_id: attrib.id }));
    }, 300);
  },
  methods: {
    getValueField(entity_attribute_id) {
      const attribute = this.dynamicAttributes.find(
        (dynamic) => dynamic.entity_attribute_id === entity_attribute_id
      );

      return attribute === undefined ? "" : attribute.value;
    },
    onDynamicField(index, entity_attribute_id, value, data_type = null) {
      if (data_type !== null) {
        this.showDate = false;
      }

      const dynamic = this.dynamicAttributes.find(
        (dynamic) => dynamic.entity_attribute_id === entity_attribute_id
      );
      const dynamicIndex = this.dynamicAttributes.indexOf(dynamic);

      this.dynamicAttributes[dynamicIndex].value = value;
      this.dynamicAttributes[dynamicIndex].entity_attribute_id =
        entity_attribute_id;

      this.$emit("form-fields", this.dynamicAttributes);
    },
    allowedDates() {
      return true;
    },
  },
};
</script>
